import { Button } from "@/components/ui";
import type { PublicPlatform } from "@/lib/api/types";
import { platformButtonLabel } from "@/lib/platform";

/** Platforms in the order the business set; the first one is the primary action. */
export function PlatformButtons({
  platforms,
  onPick,
}: {
  platforms: PublicPlatform[];
  onPick: (p: PublicPlatform) => void;
}) {
  if (platforms.length === 0) return null;
  return (
    <div className="flex flex-col gap-2">
      {platforms.map((p, i) => (
        <Button
          key={p.id}
          size="large"
          wrap
          fullWidth
          variant={i === 0 ? "solid" : "outlined"}
          color={i === 0 ? "primary" : "assistive"}
          onClick={() => onPick(p)}
          style={{ fontSize: "var(--font-size-headline-2)" }}
        >
          {platformButtonLabel(p)}
        </Button>
      ))}
      <p className="text-label-1 text-label-neutral">
        누르면 글이 복사되고, 붙여 넣는 순서를 알려 드려요. 별점은 그곳에서 직접 골라 주세요.
      </p>
    </div>
  );
}
